export default __webpack_public_path__ + "static/media/share-03.e10fa920.png";